module.exports = __webpack_public_path__ + "static/media/Stellar Max Single Headboard - 120 cm_Natural.f45a7fb8.png";